// extracted by mini-css-extract-plugin
export var cardDescription = "MagazinePreviewBlock-module--cardDescription--780e9";
export var cardImageContainer = "MagazinePreviewBlock-module--cardImageContainer--6af6a";
export var cardText = "MagazinePreviewBlock-module--cardText--8b2eb";
export var magazineCard = "MagazinePreviewBlock-module--magazineCard--ef914";
export var magazineImage = "MagazinePreviewBlock-module--magazineImage--8ae8c";
export var magazineImageContainer = "MagazinePreviewBlock-module--magazineImageContainer--93405";
export var magazineLink = "MagazinePreviewBlock-module--magazineLink--64714";
export var magazinePreviewBlockContainer = "MagazinePreviewBlock-module--magazinePreviewBlockContainer--ca643";
export var previewLink = "MagazinePreviewBlock-module--previewLink--dcb82";